import { Navigate, Route, Routes } from 'react-router-dom';

import LayoutWithSidebar from '@/app/Layout';
import GoogleAuth from '@/components/Integrations/pages/GoogleAuth';
import GoogleDriveAuth from '@/components/Integrations/pages/GoogleDriveAuth';
import HubspotAuth from '@/components/Integrations/pages/HubspotAuth';
import MicrosoftAuth from '@/components/Integrations/pages/MicrosoftAuth';
import SlackAuth from '@/components/Integrations/pages/SlackAuth';
import ModalsManager from '@/components/modals/ModalsManager';
import RoutesMap from '@/enums/RoutesMap';
import ChatPage from '@/pages/ChatPage/ChatPage';
import GoalsPage from '@/pages/GoalsPage/Goals';
import Home from '@/pages/HomePage/Home';
import JamiesCapabilities from '@/pages/JamiesCapabilities/JamiesCapabilities';
import ForgotPassword from '@/pages/LoginFlow/ForgotPassword/ForgotPassword';
import Login from '@/pages/LoginFlow/Login/Login';
import LoginFlowLayout from '@/pages/LoginFlow/LoginFlowLayout';
import ResetPassword from '@/pages/LoginFlow/ResetPassword/ResetPassword';
import SignUp from '@/pages/LoginFlow/SignUp/SignUp';
import MeetingPage from '@/pages/Meeting/MeetingPage';
import SharedMeeting from '@/pages/SharedMeeting/SharedMeeting';
import SharedPublicMeeting from '@/pages/SharedMeeting/SharedPublicMeeting';
import MeetingHubPage from '@/pages/meetingsHub/MeetingHubPage';
import { ProtectedRoute } from '@/providers/ProtectedRoute';
import Providers from '@/providers/Providers';
import useLocalStorageFF, { LOCAL_STORAGE_KEYS } from '@/utils/useLocalStorageFF';

export function App() {
  const isSlackEnabled = useLocalStorageFF(LOCAL_STORAGE_KEYS.SLACK);

  return (
    <Routes>
      <Route element={<Providers />}>
        <Route path={RoutesMap.Login} element={<LoginFlowLayout />}>
          <Route index element={<Login />} />
          <Route path={RoutesMap.LoginUserDetails} element={<Login />} />
          <Route path={RoutesMap.ForgotPassword} element={<ForgotPassword />} />
          <Route path={RoutesMap.ResetPassword} element={<ResetPassword />} />
        </Route>
        <Route path={RoutesMap.SignUp} element={<LoginFlowLayout />}>
          <Route index element={<SignUp />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route element={<ModalsManager />}>
            <Route element={<LayoutWithSidebar />}>
              <Route path={RoutesMap.Home} element={<Home />} />
              <Route path={RoutesMap.CompanyProfile} element={<Home />} />
              <Route path={RoutesMap.PersonalSettings} element={<Home />} />
              <Route path={RoutesMap.Integrations} element={<Home />} />
              <Route path={RoutesMap.Calendar} element={<Home />} />
              <Route path={RoutesMap.Tasks} element={<Home />} />

              <Route path={RoutesMap.Chat} element={<ChatPage />} />
              <Route path={RoutesMap.JamiesCapabilities} element={<JamiesCapabilities />} />
              <Route path={RoutesMap.MeetingHub} element={<MeetingHubPage />} />
              <Route path={RoutesMap.Goals} element={<GoalsPage />} />
              <Route path={RoutesMap.Meeting} element={<MeetingPage />} />

              <Route path={RoutesMap.SharedMeeting} element={<SharedMeeting />} />
            </Route>
            <Route path={RoutesMap.GoogleAuth} element={<GoogleAuth />} />
            <Route path={RoutesMap.MicrosoftAuth} element={<MicrosoftAuth />} />
            <Route path={RoutesMap.HubspotAuth} element={<HubspotAuth />} />
            {isSlackEnabled && <Route path={RoutesMap.SlackAuth} element={<SlackAuth />} />}
            <Route path={RoutesMap.GoogleDriveAuth} element={<GoogleDriveAuth />} />
          </Route>
        </Route>
        <Route path={RoutesMap.SharedPublicMeeting} element={<SharedPublicMeeting />} />
      </Route>
      <Route path="*" element={<Navigate to={RoutesMap.Home} />} />
    </Routes>
  );
}

export default App;
